window.addItemToCart = function (variant_id, qty) {
  
  let formData = {
    'items': [{
      'id': variant_id,
      'quantity': qty
    }]
  };
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {   
    var btn = document.getElementById(variant_id);
    btn.innerHTML = "Added";
    setTimeout(function() {
      btn.innerHTML = "Add to Cart";
    }, 2000);
    
    document.body.dispatchEvent(new CustomEvent('baseline:modalcart:afteradditem'));
    
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
 
}

$(document).ready(function() {
  $('.modal_btn_p a').click(function() {
    $(this).parent().parent().siblings('.modal_container_p').fadeIn();
    $('body').css('overflow', 'hidden');
  });

  $('.modal_container_p .close_modal_p').click(function() {
    $(this).parent().fadeOut();
    $('body').css('overflow', 'unset');
  });

  $('.form-plus').click(function() {
    const val = (parseInt($(this).prev().val()) + 1).toString();
    $(this).prev().val(val);
  });

  $('.form-minus').click(function() {
    const val = (parseInt($(this).next().val()) - 1).toString();
    $(this).next().val(val);
  });
});
